module.exports = __webpack_public_path__ + "img/logoPdf.80b2d168.jpg";